export const surveyEndpointIds = {
    SAVE_DROP_SURVEY: 'SAVE_DROP_SURVEY',
    GET_DROP_SURVEYS: 'GET_DROP_SURVEYS',
    GET_DROP_SURVEY: 'GET_DROP_SURVEY',
    DELETE_DROP_SURVEY: 'DELETE_DROP_SURVEY',
};
